webpackJsonp([96068746775097],{

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * object.pick <https://github.com/jonschlinkert/object.pick>
	 *
	 * Copyright (c) 2014-2015 Jon Schlinkert, contributors.
	 * Licensed under the MIT License
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(54);
	
	module.exports = function pick(obj, keys) {
	  if (!isObject(obj) && typeof obj !== 'function') {
	    return {};
	  }
	
	  var res = {};
	  if (typeof keys === 'string') {
	    if (keys in obj) {
	      res[keys] = obj[keys];
	    }
	    return res;
	  }
	
	  var len = keys.length;
	  var idx = -1;
	
	  while (++idx < len) {
	    var key = keys[idx];
	    if (key in obj) {
	      res[key] = obj[key];
	    }
	  }
	  return res;
	};


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Clamp.js 0.7.0
	 * Based on: https://github.com/xavi160/Clamp.js/commit/e313818da231b8dd8fd603dd9c9a61a9d725c22f
	 * Mixins:
	 * - https://github.com/josephschmitt/Clamp.js/pull/50
	 * - https://github.com/josephschmitt/Clamp.js/pull/49
	 *
	 * Copyright 2011-2013, Joseph Schmitt http://joe.sh
	 * Released under the WTFPL license
	 * http://sam.zoy.org/wtfpl/
	 */
	
	(function(root, factory) {
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node, CommonJS-like
	    module.exports = factory();
	  } else {
	    // Browser globals
	    root.$clamp = factory();
	  }
	}(this, function() {
	  /**
	   * Clamps a text node.
	   * @param {HTMLElement} element. Element containing the text node to clamp.
	   * @param {Object} options. Options to pass to the clamper.
	   */
	  function clamp(element, options) {
	    options = options || {};
	
	    var self = this,
	      win = window,
	      opt = {
	        clamp: options.clamp || 2,
	        useNativeClamp: typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
	        splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
	        animate: options.animate || false,
	        truncationChar: options.truncationChar || '…',
	        truncationHTML: options.truncationHTML
	      },
	
	      sty = element.style,
	      originalText = element.innerHTML,
	
	      supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
	      clampValue = opt.clamp,
	      isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
	      truncationHTMLContainer;
	
	    if (opt.truncationHTML) {
	      truncationHTMLContainer = document.createElement('span');
	      truncationHTMLContainer.innerHTML = opt.truncationHTML;
	    }
	
	
	    // UTILITY FUNCTIONS __________________________________________________________
	
	    /**
	     * Return the current style for an element.
	     * @param {HTMLElement} elem The element to compute.
	     * @param {string} prop The style property.
	     * @returns {number}
	     */
	    function computeStyle(elem, prop) {
	      if (!win.getComputedStyle) {
	        win.getComputedStyle = function(el, pseudo) {
	          this.el = el;
	          this.getPropertyValue = function(prop) {
	            var re = /(\-([a-z]){1})/g;
	            if (prop == 'float') prop = 'styleFloat';
	            if (re.test(prop)) {
	              prop = prop.replace(re, function() {
	                return arguments[2].toUpperCase();
	              });
	            }
	            return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
	          };
	          return this;
	        };
	      }
	
	      return win.getComputedStyle(elem, null).getPropertyValue(prop);
	    }
	
	    /**
	     * Returns the maximum number of lines of text that should be rendered based
	     * on the current height of the element and the line-height of the text.
	     */
	    function getMaxLines(height) {
	      var availHeight = height || (element.parentNode.clientHeight-element.offsetTop),
	        lineHeight = getLineHeight(element);
	
	      return Math.max(Math.floor(availHeight / lineHeight), 0);
	    }
	
	    /**
	     * Returns the maximum height a given element should have based on the line-
	     * height of the text and the given clamp value.
	     */
	    function getMaxHeight(clmp) {
	      var lineHeight = getLineHeight(element);
	      return lineHeight * clmp;
	    }
	
	    /**
	     * Returns the line-height of an element as an integer.
	     */
	    function getLineHeight(elem) {
	      var lh = computeStyle(elem, 'line-height');
	      if (lh == 'normal') {
	        // Normal line heights vary from browser to browser. The spec recommends
	        // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
	        lh = parseInt(computeStyle(elem, 'font-size'), 10) * 1.2;
	      }
	      return parseInt(lh, 10);
	    }
	
	
	    // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
	    var splitOnChars = opt.splitOnChars.slice(0),
	      splitChar = splitOnChars[0],
	      chunks,
	      lastChunk;
	
	    /**
	     * Gets an element's last child. That may be another node or a node's contents.
	     */
	    function getLastChild(elem) {
	      if (!elem.lastChild) {
	        return;
	      }
	      //Current element has children, need to go deeper and get last child as a text node
	      if (elem.lastChild.children && elem.lastChild.children.length > 0) {
	        return getLastChild(Array.prototype.slice.call(elem.children).pop());
	      }
	      //Handle scenario where the last child is white-space node
	      else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue === '' || elem.lastChild.nodeValue == opt.truncationChar) {
	        var sibling = elem.lastChild;
	        do {
	          if (!sibling) {
	            return;
	          }
	          //TEXT_NODE
	          if (sibling.nodeType === 3 && ['', opt.truncationChar].indexOf(sibling.nodeValue) === -1) {
	            return sibling;
	          }
	          if (sibling.lastChild) {
	            var lastChild = getLastChild(sibling);
	            if (lastChild) {
	              return lastChild;
	            }
	          }
	          //Current sibling is pretty useless
	          sibling.parentNode.removeChild(sibling);
	        } while (sibling = sibling.previousSibling);
	      }
	      //This is the last child we want, return it
	      else {
	        return elem.lastChild;
	      }
	    }
	
	    /**
	     * Removes one character at a time from the text until its width or
	     * height is beneath the passed-in max param.
	     */
	    function truncate(target, maxHeight) {
	      if (!target || !maxHeight) {
	        return;
	      }
	
	      /**
	       * Resets global variables.
	       */
	      function reset() {
	        splitOnChars = opt.splitOnChars.slice(0);
	        splitChar = splitOnChars[0];
	        chunks = null;
	        lastChunk = null;
	      }
	
	      var nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	
	      //Grab the next chunks
	      if (!chunks) {
	        //If there are more characters to try, grab the next one
	        if (splitOnChars.length > 0) {
	          splitChar = splitOnChars.shift();
	        }
	        //No characters to chunk by. Go character-by-character
	        else {
	          splitChar = '';
	        }
	
	        chunks = nodeValue.split(splitChar);
	      }
	
	      //If there are chunks left to remove, remove the last one and see if
	      // the nodeValue fits.
	      if (chunks.length > 1) {
	        // console.log('chunks', chunks);
	        lastChunk = chunks.pop();
	        // console.log('lastChunk', lastChunk);
	        applyEllipsis(target, chunks.join(splitChar));
	      }
	      //No more chunks can be removed using this character
	      else {
	        chunks = null;
	      }
	
	      //Insert the custom HTML before the truncation character
	      if (truncationHTMLContainer) {
	        target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
	        element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
	      }
	
	      //Search produced valid chunks
	      if (chunks) {
	        //It fits
	        if (element.clientHeight <= maxHeight) {
	          //There's still more characters to try splitting on, not quite done yet
	          if (splitOnChars.length >= 0 && splitChar !== '') {
	            applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
	            chunks = null;
	          }
	          //Finished!
	          else {
	            return element.innerHTML;
	          }
	        }
	      }
	      //No valid chunks produced
	      else {
	        //No valid chunks even when splitting by letter, time to move
	        //on to the next node
	        if (splitChar === '') {
	          applyEllipsis(target, '');
	          target = getLastChild(element);
	
	          reset();
	        }
	      }
	
	      //If you get here it means still too big, let's keep truncating
	      if (opt.animate) {
	        setTimeout(function() {
	          truncate(target, maxHeight);
	        }, opt.animate === true ? 10 : opt.animate);
	      } else {
	        return truncate(target, maxHeight);
	      }
	    }
	
	    function applyEllipsis(elem, str) {
	      elem.nodeValue = str + opt.truncationChar;
	    }
	
	
	    // CONSTRUCTOR ________________________________________________________________
	
	    if (clampValue == 'auto') {
	      clampValue = getMaxLines();
	    } else if (isCSSValue) {
	      clampValue = getMaxLines(parseInt(clampValue, 10));
	    }
	
	    var clampedText;
	    if (supportsNativeClamp && opt.useNativeClamp) {
	      sty.overflow = 'hidden';
	      sty.textOverflow = 'ellipsis';
	      sty.webkitBoxOrient = 'vertical';
	      sty.display = '-webkit-box';
	      sty.webkitLineClamp = clampValue;
	
	      if (isCSSValue) {
	        sty.height = opt.clamp + 'px';
	      }
	    } else {
	      var height = getMaxHeight(clampValue);
	      if (height < element.clientHeight) {
	        clampedText = truncate(getLastChild(element), height);
	      }
	    }
	
	    return {
	      'original': originalText,
	      'clamped': clampedText
	    };
	  }
	
	  return clamp;
	}));


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var clamp = __webpack_require__(60);
	var pick = __webpack_require__(53);
	var PropTypes = __webpack_require__(3);
	var ReactDOM = __webpack_require__(55);
	
	/**
	 * multuline text-overflow: ellipsis
	 */
	function Dotdotdot() {
	  if(!(this instanceof Dotdotdot)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	  this.update = this.update.bind(this);
	  this.getContainerRef = function (container) {
	    this.container = container;
	  }.bind(this);
	}
	
	Dotdotdot.prototype = Object.create(React.Component.prototype);
	Dotdotdot.prototype.componentDidMount = function() {
	  window.addEventListener('resize', this.update, false);
	  // NOTE: It's possible, not all fonts are loaded on window.load
	  window.addEventListener('load', this.update, false);
	  this.dotdotdot(ReactDOM.findDOMNode(this.container));
	};
	Dotdotdot.prototype.componentWillUnmount = function() {
	  window.removeEventListener('resize', this.update, false);
	  window.removeEventListener('load', this.update, false);
	};
	Dotdotdot.prototype.componentDidUpdate = function() {
	  this.dotdotdot(ReactDOM.findDOMNode(this.container));
	};
	
	Dotdotdot.prototype.dotdotdot = function(container) {
	  if (this.props.clamp) {
	    if (container.length) {
	      throw new Error('Please provide exacly one child to dotdotdot');
	    }
	    clamp(container, pick(this.props, [
	      'animate',
	      'clamp',
	      'splitOnChars',
	      'truncationChar',
	      'truncationHTML',
	      'useNativeClamp'
	    ]));
	  };
	};
	Dotdotdot.prototype.update = function() {
	    this.forceUpdate();
	};
	
	Dotdotdot.prototype.render = function() {
	  return React.createElement(
	    this.props.tagName,
	    {
	      ref: this.getContainerRef,
	      className: this.props.className
	    },
	    this.props.children
	  );
	};
	
	// Statics:
	Dotdotdot.propTypes = {
	  children: PropTypes.node,
	  clamp: PropTypes.oneOfType([
	    PropTypes.string,
	    PropTypes.number,
	    PropTypes.bool
	  ]).isRequired,
	  truncationChar: PropTypes.string,
	  useNativeClamp: PropTypes.bool,
	  className: PropTypes.string,
	  tagName: PropTypes.string
	};
	
	Dotdotdot.defaultProps = {
	  truncationChar: '\u2026',
	  useNativeClamp: true,
	  tagName: 'div'
	};
	
	module.exports = Dotdotdot;


/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDotdotdot = __webpack_require__(44);
	
	var _reactDotdotdot2 = _interopRequireDefault(_reactDotdotdot);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Publication = function (_React$Component) {
	  _inherits(Publication, _React$Component);
	
	  function Publication() {
	    _classCallCheck(this, Publication);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Publication.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: "publication-container col-xs-12 col-sm-12 col-md-12 col-lg-offset-1 col-lg-10 col-xl-10" },
	      _react2.default.createElement(
	        'a',
	        { href: this.props.link },
	        _react2.default.createElement(
	          'div',
	          { className: "publication" },
	          _react2.default.createElement(
	            'div',
	            { className: "title" },
	            _react2.default.createElement(
	              'h4',
	              null,
	              this.props.title
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              this.props.year
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'journal' },
	            this.props.journal,
	            '\n'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'authors' },
	            this.props.authors
	          ),
	          _react2.default.createElement(
	            _reactDotdotdot2.default,
	            { clamp: 2 },
	            _react2.default.createElement(
	              'p',
	              { className: 'abstract' },
	              this.props.abstract
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Publication;
	}(_react2.default.Component);
	
	Publication.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  authors: _propTypes2.default.string.isRequired,
	  journal: _propTypes2.default.string.isRequired,
	  year: _propTypes2.default.string.isRequired,
	  abstract: _propTypes2.default.string.isRequired,
	  link: _propTypes2.default.string,
	  linkText: _propTypes2.default.string
	};
	Publication.defaultProps = {
	  title: "Hello World",
	  year: "2016",
	  authors: "G. Yushin",
	  abstract: "The abstract of the paper goes here"
	};
	exports.default = Publication;
	module.exports = exports['default'];

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/publications.20f5f89b.jpg";

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(24);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _publications = __webpack_require__(160);
	
	var _publications2 = _interopRequireDefault(_publications);
	
	var _publication = __webpack_require__(87);
	
	var _publication2 = _interopRequireDefault(_publication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'team' },
	    _react2.default.createElement(_header2.default, {
	      image: _publications2.default,
	      title: "NANOTECH LAB | YUSHIN GROUP",
	      subtitle: "Publications"
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: "google-scholar" },
	      _react2.default.createElement(
	        'div',
	        { className: "container" },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'p',
	            { className: 'col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10' },
	            'The Yushin Group leads six main areas of interest for energy storage: conversion electrodes, selective metal dealloying, aqueous-ion storage devices, nanocomposite materials, multifunctional electrodes, and solid-state electrolytes/batteries. For a complete listing of publications, please visit ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://scholar.google.com/citations?user=TwX62mwAAAAJ&hl=en' },
	              'Google Scholar.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: "container publications" },
	      _react2.default.createElement(
	        'div',
	        { className: "row", style: { marginTop: "24px" } },
	        data.allContentfulPublication.edges.map(function (_ref2) {
	          var node = _ref2.node;
	
	          return _react2.default.createElement(_publication2.default, { key: node.id, title: node.title, journal: node.journal, authors: node.authors, year: node.year, abstract: node.description.description, link: node.url });
	        })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-publications-js-3e8f5e52c8784ef33689.js